import React, { useState, useEffect } from "react"
import { ArrowLeft, Eye, EyeOff } from "lucide-react"
import { Formik, Form, Field, ErrorMessage } from "formik"
import * as Yup from "yup"
import CustomLabel from "components/Common/CustomLabel"
import CustomField from "components/Common/CustomField"
import { useTranslation } from "react-i18next"
import { Modal } from "react-bootstrap"
import successIcon from "assets/images/icons/success-icon.svg"
import { useNavigate } from "react-router-dom"
import { changePassword } from "store/actions/authAction"
import { useDispatch } from "react-redux"
import { showAlert } from "store/reducers/alertReducer"

const initialValues = {
  password: "",
  confirmPassword: "",
}

const ConfirmPassword = ({ token, isLoading }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [show, setShow] = useState(false)
  const navigate = useNavigate()
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  const validationSchema = Yup.object().shape({
    password: Yup.string()
      .required(t("Password is required"))
      .min(8, t("Password must be at least 8 characters long"))
      .matches(/[A-Z]/, t("Must contain an uppercase letter (A-Z)"))
      .matches(/[a-z]/, t("Must contain a lowercase letter (a-z)"))
      .matches(/\d/, t("Must contain a number (0-9)"))
      .matches(
        /[!@#$%^&*(),.?":{}|<>]/,
        t("Must contain a special character (@, #, !, ...)")
      ),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], t("Passwords must match"))
      .required(t("Confirm Password is required")),
  })

  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)

  const handleReset = () => {
    navigate("/login")
  }

  const handleConfirmPassword = values => {
    const { password } = values
    const payload = {
      token: token,
      password,
    }
    dispatch(changePassword(payload))
      .then(action => {
        const { statusCode, success, message, data } = action?.payload
        if (statusCode === 200 && success) {
          console.log(data)
          dispatch(showAlert({ text: message, type: "success" }))
          handleShow()
        } else {
          dispatch(showAlert({ text: message, type: "error" }))
        }
      })
      .catch(err => {})
  }
  useEffect(() => {
    console.log(show)
  }, [show])

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleConfirmPassword}
        enableReinitialize
      >
        {({ values, errors, touched, isValid, dirty, setFieldValue }) => {
          const passwordRules = [
            {
              regex: /[A-Z]/,
              message: t("Must contain an uppercase letter (A-Z)"),
            },
            {
              regex: /[a-z]/,
              message: t("Must contain a lowercase letter (a-z)"),
            },
            { regex: /\d/, message: t("Must contain a number (0-9)") },
            {
              regex: /[!@#$%^&*(),.?":{}|<>]/,
              message: t("Must contain a special character (@, #, !, ...)"),
            },
          ]

          const isDirty = Object.keys(initialValues).length > 0 || dirty

          const isFormCompleted = isValid && isDirty

          return (
            <Form>
              <div className="form-group position-relative">
                <CustomLabel
                  htmlFor="password"
                  label={t("Password")}
                  isRequired={true}
                />
             <div className="relative">
             <CustomField
                  name="password"
                  type={showPassword ? "text" : "password"}
                  placeholder={t("Enter your password")}
                  touched={touched}
                  errors={errors}
                  
                />
                 <button
                  type="button"
                  className="password-toggle tr_btn"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
             </div>
               
              </div>

              <div className="form-group position-relative mt-3">
                <CustomLabel
                  htmlFor="confirmPassword"
                  label={t("Confirm Password")}
                  isRequired={true}
                />
               <div className="relative">
               <CustomField
                  name="confirmPassword"
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder={t("Confirm your password")}
                  touched={touched}
                  errors={errors}
                />
                <button
                  type="button"
                  className="password-toggle tr_btn"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? (
                    <EyeOff size={20} />
                  ) : (
                    <Eye size={20} />
                  )}
                </button>
               </div>
              </div>

              {/* Password Validation List */}
              <div className="password-requirements row">
                {passwordRules.map((rule, index) => (
                  <div className="col-lg-6" key={index}>
                    <p
                      style={{
                        color: rule.regex.test(values.password) ? "green" : "",
                      }}
                    >
                      {/* {rule.regex.test(values.password) ? "✔" : "✖"}{" "} */}
                      ✔ {rule.message}
                    </p>
                  </div>
                ))}
              </div>

              <button
                type="submit"
                className={`main_btn lt_font w-100 mt-5 pt_7 ${
                  isFormCompleted ? "" : "disabled-button"
                }`}
                disabled={isLoading}
              >
                {t("Verify")}
              </button>
            </Form>
          )
        }}
      </Formik>
      <Modal
        show={show}
        centered
        onHide={handleClose}
        className="success_modal"
        backdrop="static" // Prevents closing on outside click
        keyboard={false} // Prevents closing on ESC key press
      >
        <div className="d-bloxk mx-auto">
          <img width={64} height={64} src={successIcon} alt="success " />
        </div>
        <h2>
          {t("Your password has been reset")} <span>{t("successfully!")}</span>
        </h2>
        <p>{t("You can now log in using your new password.")}</p>

        <button className="main_btn" onClick={handleReset}>
          {t("Return to login")}
        </button>
      </Modal>
    </div>
  )
}

export default ConfirmPassword
